export default {
  buttons: {
    remove: 'Poista',
  },
  title: 'Alennuskoodi tai lahjakortti',
};
